(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.AiSearchPage = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var API_BASE_URL = 'https://customer-support-agent.api.liene-life.com/search-flow';

  // 仅从 URL 语言前缀取 locale（如 xxx.com/de/xxx），取不到默认英文。
  function getLanguage() {
    var match = (window.location.pathname || '').match(/^\/([a-z]{2}(?:-[a-z]{2,4})?)(?:\/|$)/i);
    return match ? match[1].toLowerCase() : 'en';
  }
  var NO_RESULTS = 'No results found. Please rephrase your question with more detail and I’ll try again.';

  function createSseParser(onEvent) {
    var buffer = '';

    function parseBlock(block) {
      var eventName = 'message';
      var dataLines = [];
      block.split(/\r?\n/).forEach(function (line) {
        if (line.indexOf('event:') === 0) eventName = line.slice(6).trim();
        if (line.indexOf('data:') === 0) dataLines.push(line.slice(5).trim());
      });
      if (!dataLines.length) return;
      try {
        onEvent({ event: eventName, data: JSON.parse(dataLines.join('\n')) });
      } catch (e) {}
    }

    function flush(completeOnly) {
      var parts = buffer.split(/\r?\n\r?\n/);
      buffer = parts.pop() || '';
      parts.forEach(parseBlock);
      if (!completeOnly && buffer.trim()) {
        parseBlock(buffer);
        buffer = '';
      }
    }

    return {
      feed: function (chunk) {
        buffer += chunk || '';
        flush(true);
      },
      finish: function () {
        flush(false);
      },
    };
  }

  function buildFeedbackUrl(baseUrl, threadId) {
    return baseUrl.replace(/\/$/, '') + '/searches/' + encodeURIComponent(threadId) + '/feedback';
  }

  function buildFeedbackBody(rating, feedback) {
    var body = { rating: rating };
    var feedbackText = String(feedback || '').trim();
    if (rating === 'not_recommended' && feedbackText) body.feedback = feedbackText;
    return body;
  }

  function flushTextDecoder(decoder) {
    return decoder.decode(new Uint8Array(0), { stream: false });
  }

  function decodeTextChunk(decoder, value) {
    if (!value || !value.length) return '';
    return decoder.decode(value, { stream: true });
  }

  async function consumeSseReader(reader, onChunk, shouldStop) {
    try {
      while (true) {
        var chunk = await reader.read();
        if (chunk.done) return null;
        onChunk(chunk.value);
        if (shouldStop()) {
          try {
            await reader.cancel();
          } catch (e) {}
          return null;
        }
      }
    } catch (error) {
      return error;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderInlineMarkdown(value) {
    var links = [];
    var withPlaceholders = String(value || '').replace(
      /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
      function (full, text, url) {
        if (!/^https?:\/\/[^\s"'<>]+$/i.test(url)) return full;
        var token = '\u0001' + links.length + '\u0001';
        links.push({ text: text, url: url });
        return token;
      },
    );

    var html = escapeHtml(withPlaceholders)
      .replace(/`([^`]+)`/g, '<code>$1</code>')
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/\*([^*]+)\*/g, '<em>$1</em>');

    links.forEach(function (link, i) {
      var href;
      try {
        href = encodeURI(link.url);
      } catch (e) {
        href = '';
      }
      if (!href || !/^https?:\/\//i.test(href)) {
        html = html.replace('\u0001' + i + '\u0001', escapeHtml('[' + link.text + '](' + link.url + ')'));
        return;
      }
      html = html.replace(
        '\u0001' + i + '\u0001',
        '<a href="' +
          escapeHtml(href) +
          '" target="_blank" rel="noopener noreferrer">' +
          escapeHtml(link.text) +
          '</a>',
      );
    });

    return html;
  }

  function renderMarkdown(value) {
    var html = [];
    var listType = '';
    var listItems = [];

    function flushList() {
      if (!listType) return;
      html.push(
        '<' +
          listType +
          '>' +
          listItems
            .map(function (item) {
              return '<li>' + renderInlineMarkdown(item) + '</li>';
            })
            .join('') +
          '</' +
          listType +
          '>',
      );
      listType = '';
      listItems = [];
    }

    String(value || '')
      .replace(/\r\n?/g, '\n')
      .split('\n')
      .forEach(function (line) {
        var unordered = line.match(/^\s*[-*]\s+(.+)$/);
        var ordered = line.match(/^\s*\d+\.\s+(.+)$/);
        if (unordered || ordered) {
          var nextType = unordered ? 'ul' : 'ol';
          if (listType && listType !== nextType) flushList();
          listType = nextType;
          listItems.push((unordered || ordered)[1]);
          return;
        }

        flushList();
        if (!line.trim()) return;
        var heading = line.match(/^\s*(#{1,3})\s+(.+)$/);
        if (heading) {
          var level = heading[1].length;
          html.push('<h' + level + '>' + renderInlineMarkdown(heading[2]) + '</h' + level + '>');
          return;
        }
        html.push('<p>' + renderInlineMarkdown(line) + '</p>');
      });
    flushList();
    return html.join('');
  }

  function init(scope) {
    var page = scope && scope.querySelector ? scope : document;
    var root = page.querySelector('[data-ai-search]');
    if (!root || root.__aiSearchReady) return;
    root.__aiSearchReady = true;

    var form = root.querySelector('[data-ai-search-form]');
    var input = root.querySelector('[data-ai-search-input]');
    var clearBtn = root.querySelector('[data-ai-search-clear]');
    var result = root.querySelector('[data-ai-search-result]');
    var answer = root.querySelector('[data-ai-search-answer]');
    var loading = root.querySelector('[data-ai-search-loading]');
    var status = root.querySelector('[data-ai-search-status]');
    var actions = root.querySelector('[data-ai-search-actions]');
    var likeBtn = root.querySelector('[data-ai-search-like]');
    var dislikeBtn = root.querySelector('[data-ai-search-dislike]');
    var copyBtn = root.querySelector('[data-ai-search-copy]');
    var feedback = root.querySelector('[data-ai-search-feedback]');
    var feedbackInput = root.querySelector('[data-ai-search-feedback-input]');
    var feedbackSubmit = root.querySelector('[data-ai-search-feedback-submit]');
    var chatBtn = root.querySelector('[data-ai-search-chat]');
    var toast = root.querySelector('[data-ai-search-toast]');

    var abortController = null;
    var threadId = '';
    var answerText = '';
    var completed = false;
    var feedbackSubmitted = false;
    var statusTimer = 0;
    var toastTimer = 0;
    var statuses = ['Analyzing your question...', 'Thinking', 'Formulating response...'];
    var mobileMedia = window.matchMedia('(max-width: 749px)');

    function syncPlaceholder() {
      var name = mobileMedia.matches ? 'data-mobile-placeholder' : 'data-desktop-placeholder';
      input.placeholder = input.getAttribute(name) || '';
    }

    syncPlaceholder();
    if (mobileMedia.addEventListener) mobileMedia.addEventListener('change', syncPlaceholder);
    else mobileMedia.addListener(syncPlaceholder);

    function showToast(message) {
      if (!toast || !message) return;
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.hidden = true;
      }, 1800);
    }

    function setSearching(searching) {
      input.disabled = searching;
      clearBtn.disabled = searching;
      root.classList.toggle('is-searching', searching);
      if (!searching) {
        clearInterval(statusTimer);
        statusTimer = 0;
      }
    }

    function startStatuses() {
      var index = 0;
      status.textContent = statuses[index];
      clearInterval(statusTimer);
      statusTimer = setInterval(function () {
        index = (index + 1) % statuses.length;
        status.textContent = statuses[index];
      }, 1400);
    }

    function resetResult() {
      threadId = '';
      answerText = '';
      completed = false;
      feedbackSubmitted = false;
      answer.textContent = '';
      answer.hidden = true;
      loading.hidden = false;
      actions.hidden = true;
      feedback.hidden = true;
      feedbackInput.value = '';
      feedbackSubmit.disabled = true;
      likeBtn.classList.remove('is-active');
      dislikeBtn.classList.remove('is-active');
      likeBtn.disabled = false;
      dislikeBtn.disabled = false;
      result.hidden = false;
    }

    function renderAnswer(text) {
      answerText = text;
      loading.hidden = true;
      answer.hidden = false;
      answer.innerHTML = renderMarkdown(text);
    }

    async function search(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();
      resetResult();
      setSearching(true);
      startStatuses();

      var streamError = '';
      try {
        var response = await fetch(API_BASE_URL + '/search/stream', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'text/event-stream',
          },
          body: JSON.stringify({
            query: query,
            context: { language: getLanguage() },
          }),
          signal: abortController.signal,
        });

        if (!response.ok) {
          var errorBody = {};
          try {
            errorBody = await response.json();
          } catch (e) {}
          throw new Error(errorBody.error || 'Request failed (' + response.status + ')');
        }

        threadId = response.headers.get('X-Search-Flow-Thread-ID') || '';
        if (!response.body || !response.body.getReader) throw new Error('Streaming is not supported by this browser.');

        var parser = createSseParser(function (message) {
          if (message.event === 'search_flow.created' && message.data.thread_id) {
            threadId = message.data.thread_id;
          } else if (message.event === 'custom' && typeof message.data.response === 'string') {
            renderAnswer(answerText + message.data.response);
          } else if (message.event === 'search_flow.error') {
            streamError = message.data.error || 'Search Flow is temporarily unavailable.';
          }
        });
        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var readError = await consumeSseReader(
          reader,
          function (value) {
            parser.feed(decodeTextChunk(decoder, value));
          },
          function () {
            return !!streamError;
          },
        );
        parser.feed(flushTextDecoder(decoder));
        parser.finish();

        if (streamError) throw new Error(streamError);
        if (readError) {
          if (!answerText || !threadId) throw readError;
          console.warn('[ai-search] SSE closed abnormally after receiving an answer.', readError);
        }
        renderAnswer(answerText || NO_RESULTS);
        completed = true;
        actions.hidden = false;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        console.error('[ai-search]', error);
        renderAnswer((error && error.message) || 'Search Flow is temporarily unavailable.');
        actions.hidden = true;
      } finally {
        if (abortController && !abortController.signal.aborted) abortController = null;
        setSearching(false);
      }
    }

    async function submitFeedback(rating) {
      if (!completed) return;
      if (!threadId) {
        showToast('Unable to submit feedback.');
        return;
      }
      if (feedbackSubmitted) return;
      try {
        var response = await fetch(buildFeedbackUrl(API_BASE_URL, threadId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(buildFeedbackBody(rating, feedbackInput.value)),
        });
        if (!response.ok) {
          var errorBody = {};
          try {
            errorBody = await response.json();
          } catch (e) {}
          throw new Error(errorBody.error || 'Request failed (' + response.status + ')');
        }
        feedbackSubmitted = true;
        likeBtn.disabled = true;
        dislikeBtn.disabled = true;
        likeBtn.classList.toggle('is-active', rating === 'recommended');
        dislikeBtn.classList.toggle('is-active', rating === 'not_recommended');
        if (rating === 'not_recommended') {
          feedback.hidden = true;
          showToast('Submit successfully');
        }
      } catch (error) {
        showToast((error && error.message) || 'Submit failed');
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input.value.trim();
      if (!query || input.disabled) return;
      search(query);
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      clearBtn.hidden = true;
    });

    input.addEventListener('input', function () {
      clearBtn.hidden = !input.value;
    });

    likeBtn.addEventListener('click', function () {
      if (feedbackSubmitted) return;
      feedback.hidden = true;
      submitFeedback('recommended');
    });

    dislikeBtn.addEventListener('click', function () {
      if (!completed) return;
      if (feedbackSubmitted) return;
      likeBtn.classList.remove('is-active');
      dislikeBtn.classList.add('is-active');
      feedback.hidden = false;
      feedbackInput.focus();
    });

    feedbackInput.addEventListener('input', function () {
      feedbackSubmit.disabled = !feedbackInput.value.trim();
    });

    feedbackSubmit.addEventListener('click', function () {
      if (!feedbackInput.value.trim()) return;
      submitFeedback('not_recommended');
    });

    copyBtn.addEventListener('click', async function () {
      if (!answerText) return;
      try {
        await navigator.clipboard.writeText(answerText);
        showToast('copied successful');
      } catch (e) {
        var textArea = document.createElement('textarea');
        textArea.value = answerText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
        showToast('copied successful');
      }
    });

    function openChatWidget() {
      var chat = window.HeroDashChatWidget;
      if (chat && typeof chat.openChat === 'function') {
        chat.openChat(true);
        return true;
      }
      if (chat && typeof chat.toggleShow === 'function') {
        chat.toggleShow(true);
        return true;
      }
      return false;
    }

    function loadChatScript() {
      if (window.HeroDashChatWidget) return;
      if (document.querySelector('[data-script-id="heroDashChatScriptId"]')) return;
      var token = (root.getAttribute('data-herodash-token') || '').trim() || 'ffd728862853ab01e30ff5510bfc0f9c';
      var script = document.createElement('script');
      script.async = true;
      script.dataset.scriptId = 'heroDashChatScriptId';
      script.src =
        'https://guest.herodash.ai/chat.js?heroDashLiveChatToken=' +
        encodeURIComponent(token) +
        '&timesMap=' +
        Math.random();
      document.head.appendChild(script);
    }

    loadChatScript();

    // 客服图标在 iframe 内，页面样式无法作用；本页通过 Start Chat 唤起，
    // 迷你悬浮态（iframe 高度很小）时隐藏 iframe，聊天窗展开后恢复显示。
    function watchChatIframe(retries) {
      var iframe = document.querySelector('iframe[id^="heroDash-chat"]');
      if (!iframe) {
        if (retries > 0)
          setTimeout(function () {
            watchChatIframe(retries - 1);
          }, 500);
        return;
      }
      var sync = function () {
        var mini = iframe.offsetHeight > 0 && iframe.offsetHeight <= 100;
        iframe.style.visibility = mini ? 'hidden' : '';
      };
      sync();
      new MutationObserver(sync).observe(iframe, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    watchChatIframe(40);

    chatBtn.addEventListener('click', function () {
      if (openChatWidget()) return;
      showToast('Chat service is loading. Please try again.');
    });

    window.addEventListener('pagehide', function () {
      if (abortController) abortController.abort();
    });

    var initialQuery = '';
    try {
      initialQuery = (new URLSearchParams(window.location.search).get('q') || '').trim();
    } catch (e) {}
    if (initialQuery) {
      input.value = initialQuery.slice(0, 200);
      clearBtn.hidden = !input.value;
      search(input.value);
    }
  }

  return {
    init: init,
  };
});
